import { render, staticRenderFns } from "./PerformancePersonConfigDetail.vue?vue&type=template&id=5f4c4b90&scoped=true&"
import script from "./PerformancePersonConfigDetail.vue?vue&type=script&lang=js&"
export * from "./PerformancePersonConfigDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f4c4b90",
  null
  
)

export default component.exports